import { ScrollTrigger } from "@gsap";

/*
 * Footer reveal (zoals de werken-bij-footer van Nova): op desktop staat de juridische balk vast onderaan, achter de pagina, en schuift het blauwe deel van de footer er bij het scrollen overheen.
 * De CSS doet de rest (zie _footer.scss); dit script meet de hoogte van de balk en zet de klasse is-reveal-ready.
 */

const footer = document.querySelector(".pk-footer");
const bar = footer?.querySelector(".footer-bottom");
const desktop = window.matchMedia("(min-width: 993px)");
const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

if (footer && bar) {
	let refreshTimer = null;

	const update = () => {
		const height = bar.getBoundingClientRect().height;
		const ready = desktop.matches && !reduceMotion.matches;

		document.documentElement.style.setProperty("--footer-height", `${height}px`);
		if (footer.classList.contains("is-reveal-ready") !== ready) {
			footer.classList.toggle("is-reveal-ready", ready);
			// De hoogte van de pagina verandert met de klasse, dus de triggers opnieuw meten.
			clearTimeout(refreshTimer);
			refreshTimer = setTimeout(() => ScrollTrigger.refresh(), 100);
		}
	};

	update();
	desktop.addEventListener("change", update);
	reduceMotion.addEventListener("change", update);
	window.addEventListener("resize", update);
	window.addEventListener("load", update, { once: true });
	document.fonts?.ready.then(update);
	if (typeof ResizeObserver !== "undefined") new ResizeObserver(update).observe(bar);

	// Een link in de balk die focus krijgt terwijl het blauwe deel er nog overheen ligt: scroll naar onderen, anders zie je niets.
	bar.addEventListener("focusin", () => {
		if (footer.classList.contains("is-reveal-ready")) window.scrollTo({ top: document.documentElement.scrollHeight });
	});
}
